import React from 'react';
import PageLayout from '../components/PageLayout';
import { Card } from '../components/ui/card';
import SEOHead from '../components/SEOHead';

export default function Privacy() {
  return (
    <PageLayout>
      <SEOHead title="Privacy Policy" description="Read the Fly N Out privacy policy. Learn how we collect, use, and protect your personal data. We never sell your information to third parties." url="/privacy" keywords="fly n out privacy policy, data protection, travel community privacy" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk' }}>Privacy Policy & Safety</h1>
        <p className="text-muted-foreground mb-8">Last updated: {new Date().toLocaleDateString()}</p>

        {[
          {
            title: 'Data We Collect',
            content: 'We collect your email address, name, and flight check-in information when you create an account. We also collect content you post (updates, messages, guide entries) and interaction data (reactions, follows). We never sell your personal data to third parties.'
          },
          {
            title: 'How We Use Your Data',
            content: 'Your data powers the community features: matching you with fellow flight passengers, personalizing your airport feed, and awarding travel badges. We use anonymized aggregate data to improve the product.'
          },
          {
            title: 'Privacy by Design',
            content: 'Your full name is never displayed publicly. Community members see only your first name and the first two letters of your last name (e.g., "Ahmed Ka."). Your email address is never visible to other users under any circumstances.'
          },
          {
            title: 'Community Safety',
            content: 'All content is reviewed by our AI moderation system and human moderators. We have a zero-tolerance policy for harassment, threats, and explicit content. Violations result in immediate account suspension. Use the report button on any post or message to flag content for review.'
          },
          {
            title: 'Payment Security',
            content: 'Premium subscription payments are processed by Moyasar, a PCI DSS-compliant payment gateway. We never store your card details. Moyasar handles all sensitive payment information.'
          },
          {
            title: 'Your Rights',
            content: 'You can request deletion of your account and data at any time by emailing info@thesaudigate.com. We will process all deletion requests within 30 days. You can also update or correct your personal information at any time via your profile settings.'
          },
        ].map(({ title, content }) => (
          <Card key={title} className="fly-card p-5 mb-4">
            <h2 className="font-semibold mb-2" style={{ fontFamily: 'Space Grotesk' }}>{title}</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">{content}</p>
          </Card>
        ))}
      </div>
    </PageLayout>
  );
}
